import {combineReducers} from "redux";
import peakInOutByRouter from "./peakInOutByRouter.reducer"
import dropdownData from "./dropdownsData.reducer"
import volumeInOutByRouter  from "./volumeInOutByRouter.reducer"
export default combineReducers({
    peakInOutByRouter,
    dropdownData,
    volumeInOutByRouter
})